/* eslint-disable react/prop-types */
/* eslint-disable react/style-prop-object */
import React, { useEffect, useState } from 'react';

function LoaderIcon({ size = 90, style }) {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prevRotation) => (prevRotation + 2) % 360);
    }, 10);

    return () => clearInterval(interval);
  }, []);

  const svgStyle = {
    ...style,
    transform: `rotate(${rotation}deg)`,
    transition: 'transform 0.01s linear',
  };
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={size}
      style={svgStyle}
      viewBox="0 0 141.7 141.7"
      xmlSpace="preserve"
      className="rotate"
    >
      <g>
        <path
          fill="#52c3b9"
          d="M70.9,7.4c-35,0-63.4,28.5-63.4,63.4s28.5,63.4,63.4,63.4c2.4,0,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4
		c-30.1,0-54.6-24.5-54.6-54.6c0-30.1,24.5-54.6,54.6-54.6c30.1,0,54.6,24.5,54.6,54.6c0,2.4,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4
		C134.3,35.9,105.8,7.4,70.9,7.4L70.9,7.4z"
        />
        <path
          fill="#29f9cc"
          d="M77.4,28.3c-1-0.1-1.9,0.5-2,1.5c-0.1,1,0.5,1.9,1.5,2c19.4,3,33.5,19.4,33.5,39c0,21.8-17.7,39.5-39.5,39.5
		c-21.8,0-39.5-17.7-39.5-39.5c0-4.6,0.8-9.2,2.4-13.6c0.3-0.9-0.1-1.9-1.1-2.3c-0.9-0.3-1.9,0.1-2.3,1.1c-1.7,4.8-2.6,9.7-2.6,14.8
		c0,23.7,19.3,43,43,43c23.7,0,43-19.3,43-43C113.9,49.5,98.5,31.6,77.4,28.3L77.4,28.3z"
        />
        <path
          fill="#2577d7"
          d="M70.9,53.3c4.6,0,8.9,1.7,12.2,4.9c0.4,0.3,0.9,0.3,1.3,0c0.3-0.4,0.3-0.9,0-1.3c-3.6-3.5-8.4-5.4-13.4-5.4
		c-10.7,0-19.5,8.7-19.5,19.5c0,10.7,8.7,19.5,19.5,19.5c8.6,0,16.2-5.7,18.7-13.9c0.1-0.5-0.1-1-0.6-1.1c-0.5-0.1-1,0.1-1.1,0.6
		c-2.2,7.5-9.2,12.7-17,12.7c-9.8,0-17.7-7.9-17.7-17.7C53.1,61.2,61.1,53.3,70.9,53.3L70.9,53.3z"
        />
      </g>
    </svg>
  );
}

export default LoaderIcon;
